import React, { useEffect, useState } from "react";
import Topbar from "../../components/Topbar/Topbar";
import { get, put } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";

function FireBaseShow() {
  const [selected, setSelected] = useState({
    id: null,
    status: true,
  });
  const [snapshot, setSnapshot] = useState(null);
  const [editing, setEditing] = useState(false);

  const getList = async () => {
    try {
      const res = await get(URLS.FIREBASE_ACTIVE);

      console.log("ASDJASDJAJS", res);

      // Adjust this line depending on your actual response shape.
      // If res is the object directly: { id, type, enabled, status, ... }
      const data = res?.data ?? res;

      setSelected({
        id: data?.id,
        status: !!data?.enabled,
      });
    } catch (err) {
      console.log(err);
    }
  };

  const paymentMethod = async (id, status) => {
    const payload = new FormData();
    payload.append("status", status);
    try {
      const res = await put(`${URLS.FIREBASE_ACTIVE}${id}/status/`, payload);
      console.log("paymentMethod res", res);
      getList();
    } catch (err) {
      console.log("ERROR", err);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  const handleEdit = () => {
    setSnapshot({ ...selected });
    setEditing(true);
  };

  const handleSubmit = async () => {
    if (snapshot && snapshot.status !== selected.status) {
      await paymentMethod(selected.id, selected.status);
    }

    setEditing(false);
    setSnapshot(null);
  };

  const handleCancel = () => {
    if (snapshot) {
      setSelected(snapshot);
    }
    setEditing(false);
    setSnapshot(null);
  };

  const handleToggle = () => {
    if (!editing) return;
    setSelected((prev) => ({
      ...prev,
      status: !prev.status,
    }));
  };

  return (
    <div>
      <Topbar header={"Fire Base "} />

      <div
        style={{
          flexDirection: "row",
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        <p style={{ fontSize: "20px" }}>Fire Base</p>
        <input
          type="checkbox"
          checked={!!selected?.status}
          readOnly
          disabled={!editing}
          style={{ width: "20px", height: "25px" }}
          onChange={handleToggle}
        />
        {!editing ? (
          <button
            onClick={handleEdit}
            className="f2 fs-sm-6 fs-md-8 fs-lg-10 fs-xl-10 fs-xxl-12 white add-btn"
          >
            Edit
          </button>
        ) : (
          <>
            <button
              onClick={handleSubmit}
              style={{
                padding: "6px 18px",
                borderRadius: 8,
                border: "none",
                background: "#7F77DD",
                color: "#fff",
                fontSize: 14,
                cursor: "pointer",
                fontWeight: 500,
              }}
            >
              Submit
            </button>
            <button
              onClick={handleCancel}
              style={{
                width: 30,
                height: 30,
                borderRadius: 8,
                border: "1px solid #e5e7eb",
                background: "#fff",
                color: "#6b7280",
                fontSize: 16,
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
              }}
            >
              ✕
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default FireBaseShow;
